import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Icon, Link, Text } from '@perch-labs/shrike';
import { copyFor, routes } from 'config';
import { useWindowSize } from 'react-use';
import { screenIsSmall } from 'utils/screen-is-small';
import { formatDate, formatAsMoney } from '@perch-labs/warbler';
import { Container, Row, RowChild, RowBuffer } from 'styles';
import { Statement } from 'hooks/use-billing-status.hook';
import { StatementBadge } from '../statement-badge';

const getCopy = copyFor('billing.dashboard.billingHistory');
interface Props {
  statement: Statement;
  includesBuffer?: boolean;
}

export const StatementRow = ({ statement, includesBuffer }: Props) => {
  const { width } = useWindowSize();
  const mobile = screenIsSmall(width);
  const { planId } = useParams<{ planId?: string }>();
  const history = useHistory();
  const from = history.location.pathname;
  const date = formatDate(statement.issuedAt, {
    format: 'MMMM dd, yyyy',
  });
  const icon = <Icon icon="ChevronRight" aria-hidden={true} />;
  const statementRoute = routes({
    statementId: statement.id,
    planId,
  }).statement;
  const state = { from };
  const kwh = statement.kwh?.total;

  return (
    <Row padding="0" onClick={() => history.push(statementRoute, state)}>
      {includesBuffer && <RowBuffer width="32px" xsmall={{ width: '0' }} />}
      <RowChild flex alignItems="baseline">
        <Container flex direction="column" alignItems="start">
          <Text>{date}</Text>
          {mobile && (
            <StatementBadge statement={statement} margin={{ top: '8px' }} />
          )}
        </Container>
        <Container flex>
          <Container flex direction="column" alignItems="end">
            <Container flex>
              {!mobile && (
                <StatementBadge
                  statement={statement}
                  margin={{ right: '8px' }}
                />
              )}
              <Text>
                {formatAsMoney(statement.total, {
                  conversion: 'fromCents',
                })}
              </Text>
            </Container>
            {kwh ? (
              <Text
                color="secondary"
                margin={{ top: '8px' }}
                textStyle="paragraph400"
              >
                {getCopy('energyUsage', { kwh })}
              </Text>
            ) : null}
          </Container>
          <Container
            margin={{
              left: '14px',
              right: includesBuffer ? '24px' : 0,
              top: '3px',
            }}
            xsmall={{ margin: { right: '24px' } }}
          >
            <Link
              aria-label={getCopy('ariaTitle', { date })}
              to={{
                pathname: statementRoute,
                state,
              }}
              hideIcon={true}
            >
              {icon}
            </Link>
          </Container>
        </Container>
      </RowChild>
    </Row>
  );
};
